var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeqropsRelationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.85,
    height: 22,
    rx: 1,
    fill: "#BFD8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.42578,
    y: 1,
    width: 19,
    height: 20,
    rx: 1,
    fill: "#083F61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_6266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 18L17.4258 18L17.4258 4L3.42578 4L3.42578 18Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92708 14.4997C6.28276 14.4997 5.76042 15.022 5.76042 15.6663C5.76042 16.3107 6.28276 16.833 6.92708 16.833C7.5714 16.833 8.09375 16.3107 8.09375 15.6663C8.09375 15.022 7.5714 14.4997 6.92708 14.4997Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40625 15.6667C8.40625 16.4834 7.74416 17.1455 6.92747 17.1455C6.11078 17.1455 5.44869 16.4834 5.44869 15.6667C5.44869 14.85 6.11078 14.1879 6.92747 14.1879C7.74417 14.1879 8.40625 14.85 8.40625 15.6667ZM6.92747 16.5213C7.39942 16.5213 7.78203 16.1387 7.78203 15.6667C7.78203 15.1948 7.39942 14.8122 6.92747 14.8122C6.45553 14.8122 6.07292 15.1948 6.07292 15.6667C6.07292 16.1387 6.45552 16.5213 6.92747 16.5213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3411 14.4997C12.6968 14.4997 12.1745 15.022 12.1745 15.6663C12.1745 16.3107 12.6968 16.833 13.3411 16.833C13.9855 16.833 14.5078 16.3107 14.5078 15.6663C14.5078 15.022 13.9855 14.4997 13.3411 14.4997Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8203 15.6667C14.8203 16.4834 14.1582 17.1455 13.3415 17.1455C12.5248 17.1455 11.8628 16.4834 11.8628 15.6667C11.8628 14.85 12.5248 14.1879 13.3415 14.1879C14.1582 14.1879 14.8203 14.85 14.8203 15.6667ZM13.3415 16.5213C13.8135 16.5213 14.1961 16.1387 14.1961 15.6667C14.1961 15.1948 13.8135 14.8122 13.3415 14.8122C12.8696 14.8122 12.487 15.1948 12.487 15.6667C12.487 16.1387 12.8696 16.5213 13.3415 16.5213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3411 5.16667C12.6968 5.16667 12.1745 5.68901 12.1745 6.33333C12.1745 6.97765 12.6968 7.5 13.3411 7.5C13.9855 7.5 14.5078 6.97765 14.5078 6.33333C14.5078 5.68901 13.9855 5.16667 13.3411 5.16667Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8203 6.33372C14.8203 7.15042 14.1582 7.8125 13.3415 7.8125C12.5248 7.8125 11.8628 7.15042 11.8628 6.33372C11.8628 5.51702 12.5248 4.85494 13.3415 4.85494C14.1582 4.85494 14.8203 5.51703 14.8203 6.33372ZM13.3415 7.18827C13.8135 7.18827 14.1961 6.80567 14.1961 6.33372C14.1961 5.86178 13.8135 5.47917 13.3415 5.47917C12.8696 5.47917 12.487 5.86177 12.487 6.33372C12.487 6.80567 12.8696 7.18827 13.3415 7.18827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3432 14.8213C13.166 14.8213 13.0223 14.6776 13.0223 14.5004L13.0223 9.68676C12.8689 9.8285 12.6967 9.95735 12.5157 10.0753C11.8886 10.4839 11.0635 10.8214 10.2761 11.1435L10.2564 11.1516C9.44559 11.4832 8.67503 11.7998 8.10429 12.1716C7.52787 12.5472 7.2474 12.9191 7.2474 13.3338L7.2474 14.5004C7.2474 14.6776 7.10374 14.8213 6.92653 14.8213C6.74933 14.8213 6.60567 14.6776 6.60567 14.5004L6.60567 13.3338C6.60567 12.5818 7.12729 12.0422 7.75399 11.6339C8.38114 11.2253 9.2062 10.8878 9.99368 10.5657L10.0134 10.5576C10.8241 10.2259 11.5947 9.90942 12.1654 9.53758C12.7419 9.16203 13.0223 8.79011 13.0223 8.37543L13.0223 7.50043C13.0223 7.32322 13.166 7.17956 13.3432 7.17956C13.5204 7.17956 13.6641 7.32322 13.6641 7.50043L13.6641 14.5004C13.6641 14.6776 13.5204 14.8213 13.3432 14.8213Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_6266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(17.4258 18) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeqropsRelationIcon);
export default __webpack_public_path__ + "static/media/seqrops_relation_Icon.723bda2008476f9cff652b1fbc424345.svg";
export { ForwardRef as ReactComponent };